import type { VisitCompliancePrintData } from '@mummssoftware/utils/api/Printing';
import { ComplianceRange } from './computeSiteCompliance';
import { SiteComplianceResult } from './types';

/**
 * OP-33263: what the widget sends to printing-service's
 * `print-visit-compliance`. It is the scored listing as displayed (the
 * services only format dates and lay the PDF out), so the print always
 * matches the screen.
 */
export const buildVisitCompliancePrintPayload = (
  result: SiteComplianceResult,
  range: ComplianceRange,
  currentUser?: mumms.User,
): VisitCompliancePrintData => ({
  fromDate: range.fromDate,
  toDate: range.toDate,
  countedThrough: result.countedThrough,
  patientsConsidered: result.patientsConsidered,
  agencyName: currentUser?.hospiceName ?? '',
  siteName: currentUser?.siteName ?? currentUser?.siteNickname ?? '',
  rows: result.rows.map((row) => ({
    displayName: row.displayName,
    patientNumber: row.patientNumber,
    missedTotal: row.missedTotal,
    missedPeriods: row.missedPeriods.map((period) => ({
      roleGroupName: period.roleGroupName,
      frequencyLabel: period.frequencyLabel,
      periodStart: period.periodStart,
      periodEnd: period.periodEnd,
      planned: period.planned,
      completed: period.completed,
      inProgress: period.inProgress,
      missed: period.missed,
    })),
  })),
});
